import { PopoverGroupOptionsMixin } from 'trunks/vue/admin/components/popover_group_options.js';

export default Vue.extend({
  mixins: [PopoverGroupOptionsMixin],

  template: `
    <popover-group-options optionsFilterPlaceholder='搜索状态'
                           :initialSelectedOptionIds='initialSelectedOptionIds'
                           :formatDataFunc='formatAttributes'
                           :needFilterInput='false'
                           ref='popoverGroupOptionsRef'
                           @cancelClicked='cancelFunc'
                           @submitClicked='submitFunc'>
      <template slot='option-item-template' slot-scope='{ option }'>
        <div class='tip gray-text'>
          <i :class='option.icon'></i>
        </div>
        <div class='content'>
          <span>{{ option.name }}</span>
        </div>
        <i class='tip primary-text' :class="option._selected ? 'slp-check-circle' : 'slp-empty'"></i>
      </template>

      <div slot='filter-blankslate' class='list-group'>
        <div class="list-group-name">没有相关的搜索结果</div>
      </div>
    </popover-group-options>
  `,

  props: {
    initialSelectedOptionIds: {
      type: Array,
    },
  },

  data() {
    return {
      tagGroups: [],
    };
  },

  methods: {
    formatAttributes() {
      return [{
        id: Skylark.Helpers.Utilities.uuid(),
        options: [
          { id: 'anonymous_allowed', name: '公开', icon: 'slp-unlock' },
          { id: 'red_packet', name: '红包', icon: 'slp-red-packet' },
          { id: 'response_required', name: '必填', icon: 'slp-asterisk' },
        ],
      }];
    },
  },
});
